import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Payment } from '@accounting/interfaces/payment';
@Component({
  name: 'bpc-print-ticket',
})
export default class PrintTicket extends Vue {
  @Prop({ type: Object, default: null }) readonly ticket;
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  readonly payments: Payment[];
  @Prop({ type: Array, default: [] }) readonly orderItems;
  @Prop({ type: String, default: null }) readonly posUserName: string;

  get readyToShow(): boolean {
    return !!this.ticket && !!this.orderItems;
  }

  destroyed() {
    const el = document.body;
    // Do not print the ticket if POS checkout not opened
    el.classList.remove('pos-checkout-opened');
  }

  get paymentsSummary(): object {
    const payments = {};
    this.payments
      ?.filter(payment => payment.status === 'paid')
      ?.forEach(item => {
        if (item.paid_amount < 0) {
          payments['returned'] = (payments['returned'] || 0) + item.paid_amount;
        } else {
          payments[item.payment_method_type] =
            (payments[item.payment_method_type] || 0) + item.paid_amount;
        }
      });
    return payments;
  }

  get totalPaidAmount(): string {
    let total = 0;
    this.payments
      ?.filter(payment => payment.status === 'paid')
      ?.forEach(payment => {
        if (payment.paid_amount > 0) {
          total = total + payment.paid_amount;
        }
      });
    return total.toString();
  }

  get totalReturnedAmount(): string {
    let total = 0;
    this.payments
      ?.filter(payment => payment.status === 'paid')
      ?.forEach(payment => {
        if (payment.paid_amount < 0) {
          total = total + payment.paid_amount;
        }
      });
    return total.toString();
  }

  get differentPaymentMethods() {
    return Object.keys(this.paymentsSummary).filter(item => item !== 'returned').length;
  }

  get logo() {
    if (
      this.$store.getters['centerSettings/centerSettings'] &&
      this.$store.getters['centerSettings/centerSettings'].logo_url
    ) {
      let logo = this.$store.getters['centerSettings/centerSettings'].logo_url;
      if (typeof logo === 'string') {
        logo = JSON.parse(logo);
      }
      return logo.url;
    }
    return null;
  }
  get ticketHeader() {
    return this.$store.getters['centerSettings/centerSettings']
      ? this.$store.getters['centerSettings/centerSettings'].ticket_header
      : null;
  }
  get ticketFooter() {
    return this.$store.getters['centerSettings/centerSettings']
      ? this.$store.getters['centerSettings/centerSettings'].ticket_footer
      : null;
  }
  formatAmount(value: string) {
    if (!value) {
      value = '0';
    }
    if (typeof value === 'string') {
      value = value.replace(',', '');
    }
    return (
      parseFloat(value)
        .toFixed(2)
        .replace('.', ',') + ' €'
    );
  }

  formatDateTime(value: string) {
    return this.$bpcHelper.formatDateTime(value);
  }

  formatDate(value: string) {
    return this.$bpcHelper.formatDate(value);
  }
}
